<template>
  <div class="geolocated-tabs">
    <div class="geolocated-tabs__filter">
      <p>Filter by</p>
      <DropdownSelect
        :class="geolocated - dropdown"
        :dropdownLabel="dropdownLabel"
        :dropdownTitle="dropdownTitle"
        :optionsArray="optionsArray"
        :valueIndexOnMount="valueIndexOnMount"
        @update:value="onOptionSelect"
      />
    </div>

    <slot :name="selectedOption" />
  </div>
</template>

<script>
import DropdownSelect from '../DropdownSelect/DropdownSelect.vue';

export default {
  components: {
    DropdownSelect,
  },
  props: {
    optionsArray: {
      type: Array,
      required: true,
    },
    valueIndexOnMount: {
      type: String,
      default: '0',
    },
    dropdownLabel: {
      type: String,
      required: false,
      default: '',
    },
    dropdownTitle: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      selectedOption: 'Value1',
    };
  },
  methods: {
    onOptionSelect(value) {
      this.selectedOption = value?.value;
    },
  },
};
</script>
